import {
  ErrorWithStatusCode,
  type Booking,
  type IContext,
} from "@/logic/api";
import type { CoreBookingView } from "./bookingTabs";

export const getBookingsView = async (
  context: IContext,
  query: CoreBookingView
): Promise<Booking[]> => {
  const url = `${context.url.replace(/\/$/, "")}/booking/getBookingsView/`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...context.headers,
    },
    body: JSON.stringify({ query }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    const message = typeof body?.error === "string" ? body.error : response.statusText;
    throw new ErrorWithStatusCode(message, response.status);
  }

  return response.json();
};
